exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disc-lists[data-v-c70485bc]{list-style:disc;margin-left:25px}", ""]);

// exports
